import * as constants from './constants';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.LOGIN:
  case constants.GET_USER:
  case constants.UPDATE_USER:
    return { ...state, loading: true };
  case constants.GET_USER_SUCCESS:
    return { ...state, loading: false, data: action.payload };
  case constants.UPDATE_USER_SUCCESS:
  case constants.LOGIN_SUCCESS:
    return { ...state, loading: false };
  case constants.GET_USER_ERROR:
  case constants.LOGIN_ERROR:
  case constants.UPDATE_USER_ERROR:
    return { ...state, loading: false, error: action.payload };
  default:
    return state;
  }
};
